import { render, staticRenderFns } from "./FormArtwork.vue?vue&type=template&id=3bbe3b46&scoped=true&"
import script from "./FormArtwork.vue?vue&type=script&lang=js&"
export * from "./FormArtwork.vue?vue&type=script&lang=js&"
import style0 from "./FormArtwork.vue?vue&type=style&index=0&id=3bbe3b46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbe3b46",
  null
  
)

export default component.exports